import React, { useState } from 'react';

function countryCodeFromFlag(flag) {
  const points = Array.from(flag || '', (character) => character.codePointAt(0));
  if (points.length !== 2 || points.some((point) => point < 0x1F1E6 || point > 0x1F1FF)) return null;
  return points.map((point) => String.fromCharCode(97 + point - 0x1F1E6)).join('');
}

export default function LanguageFlag({ flag, label, className = 'h-[18px] w-6' }) {
  const [failed, setFailed] = useState(false);
  const countryCode = countryCodeFromFlag(flag);

  if (!countryCode || failed) {
    return (
      <span aria-hidden="true" className={`inline-flex shrink-0 items-center justify-center rounded bg-indigo-100 text-indigo-600 ${className}`}>
        <svg viewBox="0 0 24 24" className="h-3.5 w-3.5" fill="none" stroke="currentColor" strokeWidth="2">
          <circle cx="12" cy="12" r="9" />
          <path d="M3 12h18M12 3c3 3.4 3 14.6 0 18M12 3c-3 3.4-3 14.6 0 18" />
        </svg>
      </span>
    );
  }

  return (
    <img
      src={`https://flagcdn.com/24x18/${countryCode}.png`}
      srcSet={`https://flagcdn.com/48x36/${countryCode}.png 2x`}
      width="24"
      height="18"
      alt=""
      aria-hidden="true"
      title={label ? `${label} flag` : undefined}
      loading="lazy"
      referrerPolicy="no-referrer"
      onError={() => setFailed(true)}
      className={`inline-block shrink-0 rounded-[2px] object-cover shadow-sm ring-1 ring-black/10 ${className}`}
    />
  );
}
